import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
// Import the logo SVG - update the path if you move the file
import logoSvg from '../../assets/logo.svg';

function Header() {
  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            {/* 
              Logo image - to change size, edit the .logo-image class in Header.css
              The SVG file is in src/assets/logo.svg
            */}
            <img src={logoSvg} alt="New Therapy AI" className="logo-image" />
          </Link>
        </div>
        <nav className="nav">
          <ul>
            <li><Link to="/chat" id='header-btn'>Chat</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header; 